// extracted by mini-css-extract-plugin
module.exports = {"notification-banner":"shared-styles-notification-banner-e2c7b405","notificationBanner":"shared-styles-notification-banner-e2c7b405"};